import type {ProductCatalogItem} from '@ozon-ai/ozon/contracts';
import {cn} from 'cn';

type ProductCatalogComboboxItemProps = {
	item: ProductCatalogItem;
	valueKey: 'ozonSku' | 'offerId';
};

function secondaryLine(item: ProductCatalogItem, valueKey: 'ozonSku' | 'offerId'): string {
	if (valueKey === 'ozonSku') {
		return [item.offerId, item.ozonSku ? `SKU ${item.ozonSku}` : null].filter(Boolean).join(' · ');
	}
	return [item.ozonSku ? `SKU ${item.ozonSku}` : null].filter(Boolean).join(' · ') || item.offerId;
}

export function ProductCatalogComboboxItem({item, valueKey}: ProductCatalogComboboxItemProps) {
	return (
		<div className="flex min-w-0 flex-1 items-center gap-2.5">
			{item.imageUrl ? (
				<img
					src={item.imageUrl}
					alt=""
					className="size-10 shrink-0 rounded-lg object-cover bg-muted"
				/>
			) : (
				<div
					className={cn(
						'flex size-10 shrink-0 items-center justify-center rounded-lg bg-muted text-base',
					)}
					aria-hidden
				>
					📦
				</div>
			)}
			<div className="flex min-w-0 flex-1 flex-col gap-0.5 text-left">
				<span className="truncate font-medium leading-snug">{item.name}</span>
				<span className="truncate text-xs text-muted-foreground">{secondaryLine(item, valueKey)}</span>
			</div>
		</div>
	);
}
